module.exports = __webpack_public_path__ + "static/media/SuperGold.b8175062.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/JoinPayment/SuperGold.png
// module id = 609
// module chunks = 0